import { Route, Routes } from 'react-router-dom';
import * as routes from '../constants/Routes';
import { Login } from '../pages/Login';
import { PasswordRecuperation } from '../pages/PasswordRecuperation';
import { Unsubscribe } from '../pages/Unsubscribe';
import { Register } from '../pages/Register';
import { Action } from '../pages/Action';
import { PaymentLead } from '../pages/PaymentLead';
import { ThanksPage } from '../pages/ThanksPage';
import { UserInactive } from '../pages/UserInactive';
import { Terms } from '../pages/Terms';
import { NotFound } from '../pages/NotFound';
import { LoggedOutHome } from '../pages/LoggedOutHome';
import { Layout } from '../components/layouts/Layout';
import { LandingBusiness } from '../pages/LandingBusiness';

export function WithoutAuth() {
  return (
    <Routes>
      <Route
        path={`${routes.UNDERLINE}/:clientAlias/public/:playerId`}
        element={
          <Layout>
            <LoggedOutHome />
          </Layout>
        }
      />

      <Route path={`${routes.UNDERLINE}/:clientAlias`} element={<Login />} />
      <Route
        path={`${routes.UNDERLINE}${routes.CORRETOR}/:clientAlias`}
        element={<Login />}
      />
      <Route
        path={`${routes.UNDERLINE}/:clientAlias/:actionId/:clientId/:playerId`}
        element={<Login />}
      />
      <Route
        path={`${routes.PASS_RECUPERATION}/:email/:clientId/:time`}
        element={<PasswordRecuperation />}
      />
      <Route
        path={`/unsubscribe/:clientId/:playerId`}
        element={<Unsubscribe />}
      />
      <Route path={`${routes.START}`} element={<Login />} />
      <Route path={`${routes.REGISTER}`} element={<Register />} />
      <Route path={routes.ACTIONSOLD} element={<Action />} />
      <Route path={routes.ACTIONS} element={<Action />} />
      <Route path={routes.LANDING_BUSSINESS} element={<LandingBusiness />} />
      <Route
        path={`${routes.UNDERLINE}${routes.PAYMENT_LEAD}/:clientId/:leadId`}
        element={<PaymentLead />}
      />

      <Route path={routes.THANKS} element={<ThanksPage />} />

      <Route path={routes.USER_INACTIVE} element={<UserInactive />} />

      <Route path={routes.TERMS} element={<Terms />} />

      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
}
